import {DynamicPickerDialog, type PublicDialogProps} from '@github-ui/filter-picker'

import {getReposItemConfig} from './ItemConfig'
import type {DynamicReposProps} from './types'

type DynamicReposPickerDialogProps = DynamicReposProps & PublicDialogProps

export function DynamicReposPickerDialog({scope, providers, ...props}: DynamicReposPickerDialogProps) {
  const itemConfig = getReposItemConfig(scope)

  return (
    <DynamicPickerDialog
      {...props}
      title="Filter"
      description="Use a query to select repositories"
      itemConfig={itemConfig}
      providers={providers}
    />
  )
}

try{ DynamicReposPickerDialog.displayName ||= 'DynamicReposPickerDialog' } catch {}